module.exports = __webpack_public_path__ + "img/propertycontrol3.fe59a8e4.png";